import { alphaSorter } from 'vet-bones/utils';
import { getInequalityValuesByIri } from 'vet-bones/utils/queryBuilder';

export const buildInequalityFilter = ({
  idsByIri,
  instancesById,
  variableIds,
  variablesById,
}: {
  idsByIri: Record<string, Set<string>>;
  instancesById: Record<string, string>;
  variableIds: Set<string>;
  variablesById: Record<string, string>;
}) => {
  const inequalityValues = getInequalityValuesByIri({
    idsByIri,
    instancesById,
    variablesById,
    variableIds,
  });

  const inequalities: string[] = [];
  Object.values(inequalityValues).forEach(({ instances, variables }) => {
    const sortedInstances = Array.from(instances).sort(alphaSorter);
    const sortedVariables = Array.from(variables).sort(alphaSorter);

    for (let i = 0; i < sortedVariables.length; i += 1) {
      sortedInstances.forEach((instanceIri) => {
        inequalities.push(`${sortedVariables[i]} != <${instanceIri}>`);
      });

      for (let j = i + 1; j < sortedVariables.length; j += 1) {
        if (sortedVariables[i] !== sortedVariables[j]) {
          inequalities.push(`${sortedVariables[i]} != ${sortedVariables[j]}`);
        }
      }
    }
  });

  return inequalities.length
    ? `FILTER(${inequalities.sort(alphaSorter).join(' && ')})`
    : '';
};
